<template>
  <div class="content">
    <progress-bar :percent="20" />
    <div class="title">Warranty contact</div>

    <div class="description">
      {{
        isUK
          ? "For warranty purposes we need the contact information for the solar energy company who is selling the system to the end customer."
          : "Please provide the best contact of the solar retailer or company who purchased this SolShare for warranty purposes."
      }}
    </div>

    <a-form-model ref="form" :colon="false" :rules="rules" :model="form">
      <a-form-model-item label="Company" prop="company">
        <a-input
          v-model.trim="form.company"
          size="large"
          class="input-box"
          placeholder="Please input company"
          data-tn="warranty-company"
        />
      </a-form-model-item>

      <a-form-model-item label="First name" prop="firstName">
        <a-input
          v-model.trim="form.firstName"
          size="large"
          class="input-box"
          placeholder="Please input first name"
          data-tn="warranty-first-name"
        />
      </a-form-model-item>

      <a-form-model-item label="Last name" prop="lastName">
        <a-input
          v-model.trim="form.lastName"
          size="large"
          class="input-box"
          placeholder="Please input last name"
          data-tn="warranty-last-name"
        />
      </a-form-model-item>

      <a-form-model-item label="Contact email" prop="contactEmail">
        <a-input
          v-model.trim="form.contactEmail"
          size="large"
          class="input-box"
          placeholder="Please input contact email"
          data-tn="warranty-contact-email"
        />
      </a-form-model-item>

      <a-form-model-item label="Contact phone" prop="contactPhone">
        <a-input
          v-model.trim="form.contactPhone"
          size="large"
          class="input-box"
          placeholder="Please input contact phone"
          data-tn="warranty-contact-phone"
        />
      </a-form-model-item>
    </a-form-model>

    <a-row type="flex" align="middle">
      <a-col :span="12">
        <back-button :style="{ marginTop: 0 }" />
      </a-col>
      <a-col :span="12">
        <yellow-button data-tn="warranty-submit" @click="submit">
          NEXT
        </yellow-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        company: [
          { required: true, message: "please input company", trigger: "blur" },
        ],
        firstName: [
          {
            required: true,
            message: "please input first name",
            trigger: "blur",
          },
        ],
        lastName: [
          {
            required: true,
            message: "please input last name",
            trigger: "blur",
          },
        ],
        contactEmail: [
          {
            required: true,
            message: "please input contact email",
            trigger: "blur",
          },
          {
            type: "email",
            message: "please input valid email",
            trigger: "blur",
          },
        ],
      },
      isSaveDisabled: false,
      form: {
        company: "",
        firstName: "",
        lastName: "",
        contactEmail: "",
        contactPhone: "",
      },
    };
  },
  computed: {
    isUK() {
      return ["GB", "UK"].includes(this.$store.state.project.address.country);
    },
  },
  created() {
    const providerContact = this.$store.state.project.providerContact || {};
    this.form = { ...this.form, ...providerContact };
  },
  methods: {
    async submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.$store.commit("setProviderContact", { ...this.form });
        await this.$router.push("/commission/2");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  .title {
    line-height: 38px;
    margin-top: 20px;
    margin-bottom: 27px;
  }

  .description {
    margin-bottom: 27px;
  }
}
</style>
